module.exports = __webpack_public_path__ + "img/WAVES-alt.a8365fc9.svg";